import { render } from "./authorization-agreement.vue?vue&type=template&id=d875b58e&scoped=true"
import script from "./authorization-agreement.vue?vue&type=script&lang=js"
export * from "./authorization-agreement.vue?vue&type=script&lang=js"

import "./authorization-agreement.vue?vue&type=style&index=0&id=d875b58e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/home_website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d875b58e"]])

export default __exports__